export const SupportedBrowsers: string[] = ['Chrome', 'Opera', 'Firefox', 'MS-Edge', 'Safari'];
